import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from 'components/shared';

import { FormFlex, FormBox } from 'components/shared/form';

import Fields from './Fields';
import Loader from './Loader';

const propTypes = {
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

function Form({ submitting, handleSubmit, loading }) {
  return (
    <form>
      {loading && <Loader />}
      {!loading && <Fields />}

      <Footer justifyContent="flex-end">
        <FormBox>
          <Button onClick={handleSubmit} rounded disabled={loading || submitting}>
            {submitting ? 'Please wait…' : 'Continue'}
          </Button>
        </FormBox>
      </Footer>
    </form>
  );
}

const Footer = styled(FormFlex)`
  padding: 1.25rem 0;
`;

Form.propTypes = propTypes;

export default Form;
